import { render, staticRenderFns } from "./TablePatientPayment.vue?vue&type=template&id=7a387758"
import script from "./TablePatientPayment.vue?vue&type=script&lang=js"
export * from "./TablePatientPayment.vue?vue&type=script&lang=js"
import style0 from "./TablePatientPayment.vue?vue&type=style&index=0&id=7a387758&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports